import { setKeyDown } from '../State/keyDown'

export default (key) => (dispatch) => {

  dispatch(setKeyDown(key))

}
